import { render, staticRenderFns } from "./TherapistMilageReimbursementList.vue?vue&type=template&id=fc01a97e&scoped=true"
import script from "./TherapistMilageReimbursementList.vue?vue&type=script&lang=js"
export * from "./TherapistMilageReimbursementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc01a97e",
  null
  
)

export default component.exports